export const headerInputCells = [
  {'name': 'Clasificación', 'serializedName': 'classification', 'width': '70px', 'required': true, 'maxLength': '5'},
  {'name': 'Días desde', 'serializedName': 'daysFrom', 'width': '70px', 'required': true, 'maxLength': '4'},
  {'name': 'Días hasta', 'serializedName': 'daysUntil', 'width': '70px', 'required': true, 'maxLength': '4'},
  {'name': 'Cost Plus', 'serializedName': 'priceFactor', 'width': '70px', 'required': true},
];

export const headerCheckboxCells = [
  {'name': 'Estado', 'serializedName': 'status', 'width': '70px'},
];
